import { action } from 'typesafe-actions';
import { ITrendingItem } from '@kattana-io/common';

const entity = 'trending';
const GET_TRENDING = `${entity}/GET`;
const SET = `${entity}/SET`;

interface ISet {
  items: ITrendingItem[],
  isError: boolean,
}

const actionGetTrending = () =>
  action(GET_TRENDING);
const actionSetTrending= (data: ISet) =>
  action(SET, data);

export {
  GET_TRENDING,
  SET,
  actionGetTrending,
  actionSetTrending,
};